import { jsx as o, jsxs as m, Fragment as $r } from "react/jsx-runtime";
import { Children as F, isValidElement as xr, createContext as wr, useContext as kr, useId as Nr, useState as br, createElement as M } from "react";
function Cr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var D = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var J;
function jr() {
  return J || (J = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a.call(this, t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, this && this[t] || t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(D)), D.exports;
}
var Sr = jr();
const dr = /* @__PURE__ */ Cr(Sr), zr = {
  "purpur-grid-item": "_purpur-grid-item_zx9tz_1",
  "purpur-grid-item--no-col-gap": "_purpur-grid-item--no-col-gap_zx9tz_6",
  "purpur-grid-item-colspan-sm-4": "_purpur-grid-item-colspan-sm-4_zx9tz_24",
  "purpur-grid-item-colspan-sm-3": "_purpur-grid-item-colspan-sm-3_zx9tz_27",
  "purpur-grid-item-colspan-sm-2": "_purpur-grid-item-colspan-sm-2_zx9tz_30",
  "purpur-grid-item-colspan-sm-1": "_purpur-grid-item-colspan-sm-1_zx9tz_33",
  "purpur-grid-item-colspan-md-8": "_purpur-grid-item-colspan-md-8_zx9tz_37",
  "purpur-grid-item-colspan-md-7": "_purpur-grid-item-colspan-md-7_zx9tz_42",
  "purpur-grid-item-colspan-md-6": "_purpur-grid-item-colspan-md-6_zx9tz_47",
  "purpur-grid-item-colspan-md-5": "_purpur-grid-item-colspan-md-5_zx9tz_52",
  "purpur-grid-item-colspan-md-4": "_purpur-grid-item-colspan-md-4_zx9tz_57",
  "purpur-grid-item-colspan-md-3": "_purpur-grid-item-colspan-md-3_zx9tz_62",
  "purpur-grid-item-colspan-md-2": "_purpur-grid-item-colspan-md-2_zx9tz_67",
  "purpur-grid-item-colspan-md-1": "_purpur-grid-item-colspan-md-1_zx9tz_72",
  "purpur-grid-item-colspan-lg-12": "_purpur-grid-item-colspan-lg-12_zx9tz_77",
  "purpur-grid-item-colspan-lg-11": "_purpur-grid-item-colspan-lg-11_zx9tz_82",
  "purpur-grid-item-colspan-lg-10": "_purpur-grid-item-colspan-lg-10_zx9tz_87",
  "purpur-grid-item-colspan-lg-9": "_purpur-grid-item-colspan-lg-9_zx9tz_92",
  "purpur-grid-item-colspan-lg-8": "_purpur-grid-item-colspan-lg-8_zx9tz_97",
  "purpur-grid-item-colspan-lg-7": "_purpur-grid-item-colspan-lg-7_zx9tz_102",
  "purpur-grid-item-colspan-lg-6": "_purpur-grid-item-colspan-lg-6_zx9tz_107",
  "purpur-grid-item-colspan-lg-5": "_purpur-grid-item-colspan-lg-5_zx9tz_112",
  "purpur-grid-item-colspan-lg-4": "_purpur-grid-item-colspan-lg-4_zx9tz_117",
  "purpur-grid-item-colspan-lg-3": "_purpur-grid-item-colspan-lg-3_zx9tz_122",
  "purpur-grid-item-colspan-lg-2": "_purpur-grid-item-colspan-lg-2_zx9tz_127",
  "purpur-grid-item-colspan-lg-1": "_purpur-grid-item-colspan-lg-1_zx9tz_77"
}, Or = dr.bind(zr), j = "purpur-grid-item", L = ({
  children: e,
  className: p,
  colSpanSm: i = 4,
  colSpanMd: a = 8,
  colSpanLg: u = 12,
  noColGap: r = !1,
  ...n
}) => {
  const t = Or([
    p,
    j,
    {
      [`${j}--no-col-gap`]: r,
      [`${j}-colspan-sm-${i}`]: i,
      [`${j}-colspan-md-${a}`]: a,
      [`${j}-colspan-lg-${u}`]: u
    }
  ]);
  return /* @__PURE__ */ o("div", { className: t, ...n, children: e });
}, qr = (e) => !!e && xr(e) && (!!e.props.colSpanSm || !!e.props.colSpanMd || !!e.props.colSpanLg);
L.displayName = "Grid.Item";
const Pr = {
  "purpur-grid": "_purpur-grid_8kjv6_1",
  "purpur-grid__inner": "_purpur-grid__inner_8kjv6_27",
  "purpur-grid__inner--no-gap": "_purpur-grid__inner--no-gap_8kjv6_32",
  "purpur-grid__inner--no-row-gap": "_purpur-grid__inner--no-row-gap_8kjv6_32",
  "purpur-grid__inner--grid": "_purpur-grid__inner--grid_8kjv6_50",
  "purpur-grid__inner--no-col-gap": "_purpur-grid__inner--no-col-gap_8kjv6_54",
  "purpur-grid__inner-col-sm-4": "_purpur-grid__inner-col-sm-4_8kjv6_57",
  "purpur-grid__inner-col-sm-3": "_purpur-grid__inner-col-sm-3_8kjv6_60",
  "purpur-grid__inner-col-sm-2": "_purpur-grid__inner-col-sm-2_8kjv6_63",
  "purpur-grid__inner-col-md-8": "_purpur-grid__inner-col-md-8_8kjv6_67",
  "purpur-grid__inner-col-md-7": "_purpur-grid__inner-col-md-7_8kjv6_72",
  "purpur-grid__inner-col-md-6": "_purpur-grid__inner-col-md-6_8kjv6_77",
  "purpur-grid__inner-col-md-5": "_purpur-grid__inner-col-md-5_8kjv6_82",
  "purpur-grid__inner-col-md-4": "_purpur-grid__inner-col-md-4_8kjv6_87",
  "purpur-grid__inner-col-md-3": "_purpur-grid__inner-col-md-3_8kjv6_92",
  "purpur-grid__inner-col-md-2": "_purpur-grid__inner-col-md-2_8kjv6_97",
  "purpur-grid__inner-col-lg-12": "_purpur-grid__inner-col-lg-12_8kjv6_102",
  "purpur-grid__inner-col-lg-11": "_purpur-grid__inner-col-lg-11_8kjv6_107",
  "purpur-grid__inner-col-lg-10": "_purpur-grid__inner-col-lg-10_8kjv6_112",
  "purpur-grid__inner-col-lg-9": "_purpur-grid__inner-col-lg-9_8kjv6_117",
  "purpur-grid__inner-col-lg-8": "_purpur-grid__inner-col-lg-8_8kjv6_122",
  "purpur-grid__inner-col-lg-7": "_purpur-grid__inner-col-lg-7_8kjv6_127",
  "purpur-grid__inner-col-lg-6": "_purpur-grid__inner-col-lg-6_8kjv6_132",
  "purpur-grid__inner-col-lg-5": "_purpur-grid__inner-col-lg-5_8kjv6_137",
  "purpur-grid__inner-col-lg-4": "_purpur-grid__inner-col-lg-4_8kjv6_142",
  "purpur-grid__inner-col-lg-3": "_purpur-grid__inner-col-lg-3_8kjv6_147",
  "purpur-grid__inner-col-lg-2": "_purpur-grid__inner-col-lg-2_8kjv6_152",
  "purpur-grid__inner--flex": "_purpur-grid__inner--flex_8kjv6_156"
}, K = dr.bind(Pr), Ar = "purpur-grid", f = "purpur-grid__inner", T = ({
  children: e,
  className: p,
  containerClassName: i,
  colsSm: a = 1,
  colsMd: u = 1,
  colsLg: r = 1,
  noGap: n = !1,
  noColGap: t = !1,
  noRowGap: s = !1,
  ...y
}) => {
  const d = F.toArray(e).filter(qr), l = d.length, h = K([i, Ar]), x = K([
    p,
    f,
    {
      [`${f}--grid`]: !l,
      [`${f}--flex`]: l,
      [`${f}--no-gap`]: n,
      [`${f}--no-col-gap`]: t,
      [`${f}--no-row-gap`]: s,
      [`${f}-col-sm-${a}`]: a > 1 && !l,
      [`${f}-col-md-${u}`]: u > 1 && !l,
      [`${f}-col-lg-${r}`]: r > 1 && !l
    }
  ]);
  return /* @__PURE__ */ o("div", { className: h, ...y, children: /* @__PURE__ */ o("div", { className: x, children: l ? F.map(d, ({ props: { children: w, ...O } }) => /* @__PURE__ */ o(L, { ...O, noColGap: n || t, children: w })) : e }) });
};
T.displayName = "Grid";
T.Item = L;
function Mr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Q = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var U;
function Vr() {
  return U || (U = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a.call(this, t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, this && this[t] || t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(Q)), Q.exports;
}
var Hr = Vr();
const Lr = /* @__PURE__ */ Mr(Hr), Tr = {
  "purpur-link": "_purpur-link_1066f_1",
  "purpur-link--text": "_purpur-link--text_1066f_18",
  "purpur-link--standalone": "_purpur-link--standalone_1066f_18",
  "purpur-link--navigation": "_purpur-link--navigation_1066f_18",
  "purpur-link--disable-visited": "_purpur-link--disable-visited_1066f_29",
  "purpur-link--text-negative": "_purpur-link--text-negative_1066f_32",
  "purpur-link--standalone-negative": "_purpur-link--standalone-negative_1066f_32",
  "purpur-link--navigation-negative": "_purpur-link--navigation-negative_1066f_32",
  "purpur-link--ensure-target-area": "_purpur-link--ensure-target-area_1066f_71",
  "purpur-link--silent": "_purpur-link--silent_1066f_77"
}, Ir = Lr.bind(Tr), k = "purpur-link", I = ({
  ["data-testid"]: e,
  children: p,
  className: i,
  disableVisited: a = !0,
  ensureTargetArea: u,
  href: r,
  negative: n = !1,
  onClick: t,
  rel: s,
  silent: y,
  target: d,
  variant: l,
  ...h
}) => (
  /* eslint-disable-next-line jsx-a11y/click-events-have-key-events */
  /* @__PURE__ */ o(
    "span",
    {
      className: Ir([
        i,
        k,
        `${k}--${n ? `${l}-negative` : l}`,
        {
          [`${k}--silent`]: y,
          [`${k}--negative`]: n,
          [`${k}--disable-visited`]: a ?? y,
          [`${k}--ensure-target-area`]: u
        }
      ]),
      "data-testid": e,
      onClick: r ? void 0 : t,
      ...h,
      children: r ? /* @__PURE__ */ o(
        "a",
        {
          href: r,
          target: d,
          rel: s,
          onClick: t,
          "data-testid": e ? `${e} a` : void 0,
          ...h,
          children: p
        }
      ) : p
    }
  )
);
I.displayName = "Link";
function Zr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var V = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var W;
function Gr() {
  return W || (W = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a.call(this, t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, this && this[t] || t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(V)), V.exports;
}
var Br = Gr();
const Z = /* @__PURE__ */ Zr(Br), _ = "purpur-footer", G = {
  "purpur-footer": "_purpur-footer_1f42w_1",
  "purpur-footer__container": "_purpur-footer__container_1f42w_8",
  "purpur-footer__logo": "_purpur-footer__logo_1f42w_29",
  "purpur-footer__logo--telia": "_purpur-footer__logo--telia_1f42w_32",
  "purpur-footer__social": "_purpur-footer__social_1f42w_52",
  "purpur-footer__social--md": "_purpur-footer__social--md_1f42w_68",
  "purpur-footer__social--sm": "_purpur-footer__social--sm_1f42w_76",
  "purpur-footer__social-link": "_purpur-footer__social-link_1f42w_85",
  "purpur-footer__navigation": "_purpur-footer__navigation_1f42w_105",
  "purpur-footer__navigation-section": "_purpur-footer__navigation-section_1f42w_114",
  "purpur-footer__navigation-section-heading": "_purpur-footer__navigation-section-heading_1f42w_117",
  "purpur-footer__navigation--lg": "_purpur-footer__navigation--lg_1f42w_140",
  "purpur-footer__navigation--sm": "_purpur-footer__navigation--sm_1f42w_154",
  "purpur-footer__custom-link-navigation": "_purpur-footer__custom-link-navigation_1f42w_178",
  "purpur-footer__payments": "_purpur-footer__payments_1f42w_200",
  "purpur-footer__payments-image": "_purpur-footer__payments-image_1f42w_216",
  "purpur-footer__contacts": "_purpur-footer__contacts_1f42w_220",
  "purpur-footer__contacts-copyright": "_purpur-footer__contacts-copyright_1f42w_234",
  "purpur-footer__contacts-address": "_purpur-footer__contacts-address_1f42w_239",
  "purpur-footer__additional": "_purpur-footer__additional_1f42w_243",
  "purpur-footer__additional-links": "_purpur-footer__additional-links_1f42w_260",
  "purpur-footer__custom-content": "_purpur-footer__custom-content_1f42w_272"
};
function Er(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var X = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Y;
function Rr() {
  return Y || (Y = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a(t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(X)), X.exports;
}
var Fr = Rr();
const Dr = /* @__PURE__ */ Er(Fr), q = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, Jr = {
  TITLE100: "title-100"
}, P = "purpur-heading", B = ({
  children: e,
  className: p = "",
  enableHyphenation: i = !1,
  negative: a = !1,
  tag: u,
  variant: r = Jr.TITLE100,
  ...n
}) => {
  const t = u, s = Dr([
    p,
    q[P],
    q[`${P}--${r}`],
    {
      [q[`${P}--hyphens`]]: i,
      [q[`${P}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ o(t, { className: s, ...n, children: e });
};
B.displayName = "Heading";
function Kr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var er;
function Qr() {
  return er || (er = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a.call(this, t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, this && this[t] || t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(rr)), rr.exports;
}
var Ur = Qr();
const gr = /* @__PURE__ */ Kr(Ur), Wr = {
  "purpur-accordion": "_purpur-accordion_u887g_1",
  "purpur-accordion__title": "_purpur-accordion__title_u887g_4",
  "purpur-accordion--negative": "_purpur-accordion--negative_u887g_13"
};
function Xr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ir;
function Yr() {
  return ir || (ir = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a.call(this, t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, this && this[t] || t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(nr)), nr.exports;
}
var re = Yr();
const ee = /* @__PURE__ */ Xr(re), ne = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, ie = ee.bind(ne), tr = "purpur-icon", te = "md", pe = (e) => e.filter((p) => Object.keys(p).length >= 1).map((p) => `${p.name}="${p.value}"`).join(" "), ae = ({ content: e = "", title: p } = {}) => {
  const i = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    p ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = p ? `<title>${p}</title>` : "";
  return `<svg ${pe(i)}>${a}${e}</svg>`;
}, ue = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), mr = ({
  ["data-testid"]: e,
  svg: p,
  allyTitle: i,
  className: a,
  size: u = te,
  ...r
}) => {
  const n = ae({
    content: ue(p.svg),
    title: i
  }), t = ie(a, tr, `${tr}--${u}`);
  return /* @__PURE__ */ o(
    "span",
    {
      className: t,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: n },
      ...r
    }
  );
};
mr.displayName = "Icon";
const oe = {
  name: "chevron-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.136 7.864a.9.9 0 0 0-1.272 0L12 14.727 5.136 7.864a.9.9 0 0 0-1.272 1.272l7.5 7.5a.9.9 0 0 0 1.272 0l7.5-7.5a.9.9 0 0 0 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-down"],
  category: "utility"
}, hr = (e) => /* @__PURE__ */ o(mr, { ...e, svg: oe });
hr.displayName = "IconChevronDown";
function _e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ar;
function le() {
  return ar || (ar = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a(t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(pr)), pr.exports;
}
var se = le();
const ce = /* @__PURE__ */ _e(se), S = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, de = {
  PARAGRAPH100: "paragraph-100"
}, z = "purpur-paragraph", fr = ({
  ["data-testid"]: e,
  children: p,
  className: i,
  disabled: a,
  enableHyphenation: u = !1,
  negative: r = !1,
  variant: n = de.PARAGRAPH100,
  ...t
}) => {
  const s = ce([
    i,
    S[z],
    S[`${z}--${n}`],
    {
      [S[`${z}--hyphens`]]: u,
      [S[`${z}--disabled`]]: a,
      [S[`${z}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ o("p", { ...t, className: s, "data-testid": e, children: p });
};
fr.displayName = "Paragraph";
const ge = {
  "purpur-accordion-item": "_purpur-accordion-item_12e59_1",
  "purpur-accordion-item__header": "_purpur-accordion-item__header_12e59_10",
  "purpur-accordion-item__trigger": "_purpur-accordion-item__trigger_12e59_13",
  "purpur-accordion-item__trigger__icon": "_purpur-accordion-item__trigger__icon_12e59_43",
  "purpur-accordion-item__title": "_purpur-accordion-item__title_12e59_49",
  "purpur-accordion-item__icon": "_purpur-accordion-item__icon_12e59_50",
  "purpur-accordion-item__rotate": "_purpur-accordion-item__rotate_12e59_64",
  "purpur-accordion-item__content": "_purpur-accordion-item__content_12e59_67",
  "purpur-accordion-item__contentText": "_purpur-accordion-item__contentText_12e59_78",
  "purpur-accordion-item--negative": "_purpur-accordion-item--negative_12e59_99"
}, N = gr.bind(ge), v = "purpur-accordion-item", me = ({
  children: e,
  className: p,
  title: i,
  titleTag: a = "h3",
  initialOpen: u = !1,
  onClick: r,
  onOpen: n,
  onClose: t,
  ...s
}) => {
  const y = kr(vr), d = Nr(), [l, h] = br(!u), x = N([
    p,
    v,
    {
      [`${v}--negative`]: y
    }
  ]);
  return /* @__PURE__ */ m("div", { className: x, ...s, children: [
    /* @__PURE__ */ o(
      B,
      {
        tag: a,
        variant: "title-100",
        className: N([`${v}__header`, `${v}__title`]),
        children: /* @__PURE__ */ m(
          "button",
          {
            type: "button",
            "data-state": l ? "open" : "close",
            onClick: (w) => {
              r && r(w), l ? n && n() : t && t(), h(!l);
            },
            className: N(`${v}__trigger`, p, {
              [`${v}__rotate`]: !l
            }),
            "aria-expanded": !l,
            "aria-controls": d,
            id: d + "button",
            children: [
              i,
              /* @__PURE__ */ o(hr, { size: "md", className: N(`${v}__icon`), "aria-hidden": !0 })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: N(`${v}__content`, p),
        "aria-hidden": l,
        id: d,
        "aria-labelledby": d + "button",
        role: "region",
        children: /* @__PURE__ */ o("div", { className: N(`${v}__contentText`), children: typeof e == "string" ? /* @__PURE__ */ o(fr, { variant: "paragraph-200", children: e }) : e })
      }
    )
  ] });
}, ur = gr.bind(Wr), H = "purpur-accordion", vr = wr(!1), A = ({
  children: e,
  className: p,
  negative: i = !1,
  title: a,
  titleTag: u = "h2",
  titleVariant: r = "title-300",
  schema: n,
  ...t
}) => {
  const s = ur([
    p,
    H,
    {
      [`${H}--negative`]: i
    }
  ]);
  return /* @__PURE__ */ m("div", { className: s, ...t, children: [
    a && /* @__PURE__ */ o(B, { tag: u, variant: r, className: ur(`${H}__title`), children: a }),
    /* @__PURE__ */ o(vr.Provider, { value: i, children: e }),
    n && /* @__PURE__ */ o(
      "script",
      {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: n
        }
      }
    )
  ] });
};
A.Item = me;
A.displayName = "Accordion";
const b = Z.bind(G), or = ({ links: e, customLink: p }) => /* @__PURE__ */ o("ul", { children: e.map((i, a) => /* @__PURE__ */ o("li", { children: p ? /* @__PURE__ */ o(p, { href: i.href, className: b(`${_}__custom-link-navigation`), children: i.text }) : /* @__PURE__ */ o(I, { variant: "navigation", negative: !0, href: i.href, disableVisited: !0, children: i.text }) }, a)) }), he = ({
  navigationLinks: e,
  sectionProps: p,
  customLink: i
}) => /* @__PURE__ */ m($r, { children: [
  /* @__PURE__ */ o(
    "section",
    {
      ...p,
      className: b(
        `${_}__navigation`,
        `${_}__navigation--lg`,
        p == null ? void 0 : p.className
      ),
      children: e.map((a, u) => /* @__PURE__ */ m("div", { className: b(`${_}__navigation-section`), children: [
        /* @__PURE__ */ o("h3", { className: b(`${_}__navigation-section-heading`), children: a.heading }),
        /* @__PURE__ */ o(or, { links: a.links, customLink: i })
      ] }, u))
    }
  ),
  /* @__PURE__ */ o(
    "section",
    {
      ...p,
      className: b(
        `${_}__navigation`,
        `${_}__navigation--sm`,
        p == null ? void 0 : p.className
      ),
      children: /* @__PURE__ */ o(A, { negative: !0, children: e.map((a, u) => /* @__PURE__ */ o(
        A.Item,
        {
          value: `${u}`,
          title: a.heading,
          titleTag: "h2",
          className: b(`${_}__navigation-section`),
          children: /* @__PURE__ */ o(or, { links: a.links, customLink: i })
        },
        u
      )) })
    }
  )
] });
function fe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _r = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var lr;
function ve() {
  return lr || (lr = 1, function(e) {
    (function() {
      var p = {}.hasOwnProperty;
      function i() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var t = arguments[n];
          t && (r = u(r, a.call(this, t)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return i.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var t in r)
          p.call(r, t) && r[t] && (n = u(n, this && this[t] || t));
        return n;
      }
      function u(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
    })();
  }(_r)), _r.exports;
}
var ye = ve();
const $e = /* @__PURE__ */ fe(ye), xe = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, we = $e.bind(xe), sr = "purpur-icon", ke = "md", Ne = (e) => e.filter((p) => Object.keys(p).length >= 1).map((p) => `${p.name}="${p.value}"`).join(" "), be = ({ content: e = "", title: p } = {}) => {
  const i = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    p ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = p ? `<title>${p}</title>` : "";
  return `<svg ${Ne(i)}>${a}${e}</svg>`;
}, Ce = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), yr = ({
  ["data-testid"]: e,
  svg: p,
  allyTitle: i,
  className: a,
  size: u = ke,
  ...r
}) => {
  const n = be({
    content: Ce(p.svg),
    title: i
  }), t = we(a, sr, `${sr}--${u}`);
  return /* @__PURE__ */ o(
    "span",
    {
      className: t,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: n },
      ...r
    }
  );
};
yr.displayName = "Icon";
const je = Z.bind(G), cr = ({ icon: e, href: p, ...i }) => /* @__PURE__ */ o(
  "a",
  {
    ...i,
    href: p,
    className: je(`${_}__social-link`),
    rel: "noreferrer",
    target: "_blank",
    children: /* @__PURE__ */ o(yr, { svg: e })
  }
), Se = () => /* @__PURE__ */ m(
  "svg",
  {
    width: "81",
    height: "32",
    viewBox: "0 0 81 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ m("g", { clipPath: "url(#clip0_5309_7721)", children: [
        /* @__PURE__ */ o(
          "path",
          {
            d: "M81.28 16.8043V25.2064H78.5458V23.8293C77.6183 25.04 76.1438 25.4912 74.9076 25.4912C72.3401 25.4912 70.8186 23.8773 70.8186 21.8592C70.8186 19.5573 73.4107 17.6821 76.5723 17.6821C77.1909 17.6821 77.8566 17.7301 78.4507 17.92V17.1371C78.4507 15.9499 77.7615 15.3333 76.3586 15.3333C75.0989 15.3333 73.9812 15.9744 73.2921 16.8053L71.2235 15.2864C72.3882 13.9339 74.3862 12.9845 76.4067 12.9845C79.5683 12.9824 81.28 14.3595 81.28 16.8043ZM78.4507 20.6251V20.1024C77.9752 19.936 77.4762 19.8891 76.8576 19.8891C74.7174 19.8891 73.6244 20.7435 73.6244 21.7877C73.6244 22.6421 74.3616 23.1883 75.4792 23.1883C76.9527 23.1883 78.4507 22.3104 78.4507 20.6251Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M65.8021 9.968C65.8021 9.04214 66.6109 8.28267 67.5373 8.28267C68.4412 8.28267 69.249 9.04214 69.249 9.968C69.249 10.8939 68.4401 11.6533 67.5373 11.6533C66.6109 11.6533 65.8021 10.8939 65.8021 9.968ZM66.0638 25.2064V13.3387H68.9883V25.2064H66.0638Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M64.2806 25.2533C63.8286 25.3483 63.3531 25.3717 62.9257 25.3717C60.8337 25.3717 59.9062 24.3744 59.9062 22.3573V8.59093H62.8306V21.9541C62.8306 22.9749 63.4493 23.1168 64.2806 23.0219V25.2533Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M58.0513 20.1035H49.2781C49.5869 21.8603 50.8477 23.0229 52.4643 23.0229C53.677 23.0229 54.6514 22.4768 55.2466 21.5755L57.5769 22.976C56.3877 24.5664 54.4388 25.5157 52.4653 25.5157C49.2086 25.5157 46.3793 22.9291 46.3793 19.2256C46.3793 15.5221 49.1851 12.96 52.3232 12.96C56.4347 12.9589 58.4552 16.2347 58.0513 20.1035ZM49.3732 17.8955H55.222C54.8651 16.3531 53.8672 15.3792 52.3211 15.3792C50.8712 15.3803 49.7771 16.3765 49.3732 17.8955Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M48.6359 11.2971H43.69V25.2064H40.5518V11.2971H35.5589V8.59093H48.6359V11.2971Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M16.9321 27.4656C11.5983 29.6245 8.54567 28.9365 6.85855 27.5904L6.83397 27.5712C9.44532 30.1717 12.4221 32.0011 15.0324 32.0011C19.6033 32.0011 25.8614 26.4651 28.8232 17.8805C27.1542 20.9792 23.5727 24.7861 16.9321 27.4656Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M20.9806 22.4843C25.137 20.0779 28.8809 15.9968 30.0616 13.0869C30.3971 10.6784 30.4654 10.3744 30.506 7.7248C30.5114 7.35787 30.4889 7.00587 30.4548 6.6688C30.2122 10.56 25.1743 15.4528 18.5092 18.6496C10.4689 22.5056 4.43738 23.5435 1.74589 20.6027C2.6808 22.4459 3.29411 23.3408 4.34549 24.7083C7.45048 27.4539 13.9853 26.5355 20.9806 22.4843Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            d: "M17.5721 15.8923C25.1562 12.24 30.4387 7.04427 29.5177 3.6C28.0058 0.993067 24.9457 0 21.6644 0C11.9381 0 0 6.4 0 14.5653C0 15.6149 0.231859 16.7883 0.647496 18.0181C2.86565 20.9568 9.64833 19.7077 17.5721 15.8923Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "clip0_5309_7721", children: /* @__PURE__ */ o("rect", { width: "81", height: "32", fill: "white" }) }) })
    ]
  }
), c = Z.bind(G), ze = ({
  className: e,
  navigation: p,
  social: i,
  contacts: a,
  additional: u,
  custom: r,
  payments: n,
  logo: t,
  ...s
}) => {
  var d, l, h, x, w, O, E, R;
  const y = c([e, _]);
  return /* @__PURE__ */ o("footer", { className: y, ...s, children: /* @__PURE__ */ o(T, { children: /* @__PURE__ */ m("div", { className: c(`${_}__container`), children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: c(`${_}__logo`, {
          [`${_}__logo--telia`]: !t
        }),
        children: t ?? /* @__PURE__ */ o(Se, {})
      }
    ),
    i && /* @__PURE__ */ o(
      "section",
      {
        ...i.sectionProps,
        className: c(
          `${_}__social`,
          `${_}__social--md`,
          (d = i.sectionProps) == null ? void 0 : d.className
        ),
        children: i.links.map(({ icon: $, href: g, ...C }) => /* @__PURE__ */ M(cr, { ...C, icon: $, href: g, key: g }))
      }
    ),
    p && /* @__PURE__ */ o(
      he,
      {
        customLink: p.customLink,
        navigationLinks: p.links,
        sectionProps: p.sectionProps
      }
    ),
    n && /* @__PURE__ */ o(
      "section",
      {
        ...n.sectionProps,
        className: c(`${_}__payments`, (l = n.sectionProps) == null ? void 0 : l.className),
        children: n.images.map(({ alt: $, src: g }) => /* @__PURE__ */ o(
          "img",
          {
            className: c(`${_}__payments-image`),
            src: g,
            alt: $
          },
          g
        ))
      }
    ),
    a && /* @__PURE__ */ m(
      "section",
      {
        ...a.sectionProps,
        className: c(`${_}__contacts`, (h = a.sectionProps) == null ? void 0 : h.className),
        children: [
          a.copyright && /* @__PURE__ */ o("div", { className: c(`${_}__contacts-copyright`), children: a.copyright }),
          a.address && /* @__PURE__ */ o(
            "address",
            {
              ...a.address.addressProps,
              className: c(
                `${_}__contacts-address`,
                (x = a.address.addressProps) == null ? void 0 : x.className
              ),
              children: a.address.content
            }
          )
        ]
      }
    ),
    (r || u) && /* @__PURE__ */ m("div", { className: c(`${_}__additional`), children: [
      r && /* @__PURE__ */ o(
        "section",
        {
          ...r.sectionProps,
          className: c(`${_}__custom-content`, (w = r.sectionProps) == null ? void 0 : w.className),
          children: r.content
        }
      ),
      u && /* @__PURE__ */ o(
        "section",
        {
          ...u.sectionProps,
          className: c(
            `${_}__additional-links`,
            (O = u.sectionProps) == null ? void 0 : O.className
          ),
          children: (E = u == null ? void 0 : u.links) == null ? void 0 : E.map(({ href: $, text: g, ...C }) => /* @__PURE__ */ M(
            I,
            {
              ...C,
              variant: "standalone",
              negative: !0,
              href: $,
              key: $,
              disableVisited: !0
            },
            g
          ))
        }
      )
    ] }),
    i && /* @__PURE__ */ o(
      "section",
      {
        ...i.sectionProps,
        className: c(
          `${_}__social`,
          `${_}__social--sm`,
          (R = i.sectionProps) == null ? void 0 : R.className
        ),
        children: i.links.map(({ icon: $, href: g, ...C }) => /* @__PURE__ */ M(cr, { ...C, icon: $, href: g, key: g }))
      }
    )
  ] }) }) });
};
ze.displayName = "Footer";
export {
  ze as Footer
};
//# sourceMappingURL=footer.es.js.map
